import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ProducerScopeb3mmhvfa6ll7 as ProducerScope,
  produce3s4oh9balbl5b as produce,
} from '../../channels/Produce.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emitAll233y0vrwmloef as emitAll } from '../Channels.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope5mg03ltqqkp0 as coroutineScope,
} from '../../CoroutineScope.mjs';
import { BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance } from '../../channels/BufferOverflow.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineStart_ATOMIC_getInstance1xsp76269lswt as CoroutineStart_ATOMIC_getInstance } from '../../CoroutineStart.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from '../../Debug.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { SendingCollector33jb503i6hglm as SendingCollector } from './SendingCollector.mjs';
import { newCoroutineContext1x74axajiiptk as newCoroutineContext } from '../../CoroutineContext.mjs';
import { Key_instancesrycfl6s632h as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { NopCollector2h4omm21qc7hq as NopCollector } from './NopCollector.mjs';
import { threadContextElements12yd4mfmaodla as threadContextElements } from '../../internal/ThreadContext.mjs';
import { startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
function ChannelFlow$_get_collectToFun_$slambda_j53z2e() {
  if (ChannelFlow$_get_collectToFun_$slambda_j53z2eClass === VOID) {
    class $ {
      constructor(this$0) {
        this.n1f_1 = this$0;
      }
      *o1f(it, $completion) {
        yield* this.n1f_1.v1c(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1f((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$_get_collectToFun_$slambda_j53z2eClass = $;
  }
  return ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
}
function ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this$0) {
  var i = new (ChannelFlow$_get_collectToFun_$slambda_j53z2e())(this$0);
  var l = (it, $completion) => i.o1f(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlow$collect$slambdaClass;
function ChannelFlow$collect$slambda() {
  if (ChannelFlow$collect$slambdaClass === VOID) {
    class $ {
      constructor($collector, this$0) {
        this.p1f_1 = $collector;
        this.q1f_1 = this$0;
      }
      *r1f($this$coroutineScope, $completion) {
        yield* emitAll(this.p1f_1, this.q1f_1.d1d($this$coroutineScope), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$collect$slambdaClass = $;
  }
  return ChannelFlow$collect$slambdaClass;
}
function ChannelFlow$collect$slambda_0($collector, this$0) {
  var i = new (ChannelFlow$collect$slambda())($collector, this$0);
  var l = ($this$coroutineScope, $completion) => i.r1f($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowClass;
function ChannelFlow() {
  if (ChannelFlowClass === VOID) {
    class $ {
      constructor(context, capacity, onBufferOverflow) {
        this.w1c_1 = context;
        this.x1c_1 = capacity;
        this.y1c_1 = onBufferOverflow;
        // Inline function 'kotlinx.coroutines.assert' call
      }
      z1c() {
        return ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this);
      }
      a1d() {
        return this.x1c_1 === -3 ? -2 : this.x1c_1;
      }
      b1d(context, capacity, onBufferOverflow) {
        // Inline function 'kotlinx.coroutines.assert' call
        var newContext = context.gm(this.w1c_1);
        var newCapacity;
        var newOverflow;
        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          newCapacity = capacity;
          newOverflow = onBufferOverflow;
        } else {
          var tmp;
          if (this.x1c_1 === -3) {
            tmp = capacity;
          } else if (capacity === -3) {
            tmp = this.x1c_1;
          } else if (this.x1c_1 === -2) {
            tmp = capacity;
          } else if (capacity === -2) {
            tmp = this.x1c_1;
          } else {
            // Inline function 'kotlinx.coroutines.assert' call
            // Inline function 'kotlinx.coroutines.assert' call
            var sum = this.x1c_1 + capacity | 0;
            tmp = sum >= 0 ? sum : 2147483647;
          }
          newCapacity = tmp;
          newOverflow = this.y1c_1;
        }
        if (equals(newContext, this.w1c_1) && newCapacity === this.x1c_1 && newOverflow.equals(this.y1c_1))
          return this;
        return this.u1c(newContext, newCapacity, newOverflow);
      }
      d1d(scope) {
        return produce(scope, this.w1c_1, this.a1d(), this.y1c_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.z1c());
      }
      *p1c(collector, $completion) {
        return yield* coroutineScope(ChannelFlow$collect$slambda_0(collector, this), $completion);
      }
      e1d() {
        return null;
      }
      toString() {
        var props = ArrayList().h2(4);
        var tmp0_safe_receiver = this.e1d();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          props.i2(tmp0_safe_receiver);
        }
        if (!(this.w1c_1 === EmptyCoroutineContext_instance)) {
          props.i2('context=' + toString(this.w1c_1));
        }
        if (!(this.x1c_1 === -3)) {
          props.i2('capacity=' + this.x1c_1);
        }
        if (!this.y1c_1.equals(BufferOverflow_SUSPEND_getInstance())) {
          props.i2('onBufferOverflow=' + this.y1c_1.toString());
        }
        return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
      }
    }
    protoOf($).c1d = fuse$default;
    initMetadataForClass($, 'ChannelFlow', VOID, VOID, [FusibleFlow()], [1]);
    ChannelFlowClass = $;
  }
  return ChannelFlowClass;
}
function fuse$default(context, capacity, onBufferOverflow, $super) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? -3 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  return $super === VOID ? this.b1d(context, capacity, onBufferOverflow) : $super.b1d.call(this, context, capacity, onBufferOverflow);
}
var FusibleFlowClass;
function FusibleFlow() {
  if (FusibleFlowClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FusibleFlow', VOID, VOID, VOID, [1]);
    FusibleFlowClass = $;
  }
  return FusibleFlowClass;
}
var ChannelFlowOperatorImplClass;
function ChannelFlowOperatorImpl() {
  if (ChannelFlowOperatorImplClass === VOID) {
    class $ extends ChannelFlowOperator() {
      constructor(flow, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -3 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(flow, context, capacity, onBufferOverflow);
      }
      u1c(context, capacity, onBufferOverflow) {
        return new (ChannelFlowOperatorImpl())(this.z1f_1, context, capacity, onBufferOverflow);
      }
      *a1g(collector, $completion) {
        return yield* this.z1f_1.p1c(collector, $completion);
      }
    }
    initMetadataForClass($, 'ChannelFlowOperatorImpl', VOID, VOID, VOID, [1]);
    ChannelFlowOperatorImplClass = $;
  }
  return ChannelFlowOperatorImplClass;
}
function *collectWithContextUndispatched($this, collector, newContext, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.mc();
  var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
  return yield* withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda_0($this), $completion);
}
var ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
function ChannelFlowOperator$collectWithContextUndispatched$slambda() {
  if (ChannelFlowOperator$collectWithContextUndispatched$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.b1g_1 = this$0;
      }
      *c1g(it, $completion) {
        yield* this.b1g_1.a1g(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlowOperator$collectWithContextUndispatched$slambdaClass = $;
  }
  return ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
}
function ChannelFlowOperator$collectWithContextUndispatched$slambda_0(this$0) {
  var i = new (ChannelFlowOperator$collectWithContextUndispatched$slambda())(this$0);
  var l = (it, $completion) => i.c1g(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowOperatorClass;
function ChannelFlowOperator() {
  if (ChannelFlowOperatorClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(flow, context, capacity, onBufferOverflow) {
        super(context, capacity, onBufferOverflow);
        this.z1f_1 = flow;
      }
      *v1c(scope, $completion) {
        return yield* this.a1g(new (SendingCollector())(scope), $completion);
      }
      *p1c(collector, $completion) {
        if (this.x1c_1 === -3) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          var collectContext = $completion.mc();
          var newContext = newCoroutineContext(collectContext, this.w1c_1);
          if (equals(newContext, collectContext))
            return yield* this.a1g(collector, $completion);
          if (equals(newContext.yc(Key_instance), collectContext.yc(Key_instance)))
            return yield* /*#__NOINLINE__*/collectWithContextUndispatched(this, collector, newContext, $completion);
        }
        yield* super.p1c(collector, $completion);
        return Unit_instance;
      }
      toString() {
        return toString(this.z1f_1) + ' -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowOperator', VOID, VOID, VOID, [1, 2]);
    ChannelFlowOperatorClass = $;
  }
  return ChannelFlowOperatorClass;
}
function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof SendingCollector()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof NopCollector();
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (UndispatchedContextCollector())(_this__u8e3s4, emitContext);
  }
  return tmp;
}
function *withContextUndispatched(newContext, value, countOrElement, block, $completion) {
  countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
  // Inline function 'kotlinx.coroutines.withCoroutineContext' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var tmp0 = block;
    var tmp2 = value;
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new (StackFrameContinuation())(uCont, newContext);
    return startCoroutineUninterceptedOrReturnGeneratorVersion(tmp0, tmp2, completion);
  };
}
var UndispatchedContextCollector$emitRef$slambdaClass;
function UndispatchedContextCollector$emitRef$slambda() {
  if (UndispatchedContextCollector$emitRef$slambdaClass === VOID) {
    class $ {
      constructor($downstream) {
        this.d1g_1 = $downstream;
      }
      *e1g(it, $completion) {
        yield* this.d1g_1.h1d(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.e1g(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UndispatchedContextCollector$emitRef$slambdaClass = $;
  }
  return UndispatchedContextCollector$emitRef$slambdaClass;
}
function UndispatchedContextCollector$emitRef$slambda_0($downstream) {
  var i = new (UndispatchedContextCollector$emitRef$slambda())($downstream);
  var l = (it, $completion) => i.e1g(it, $completion);
  l.$arity = 1;
  return l;
}
var UndispatchedContextCollectorClass;
function UndispatchedContextCollector() {
  if (UndispatchedContextCollectorClass === VOID) {
    class $ {
      constructor(downstream, emitContext) {
        this.f1g_1 = emitContext;
        this.g1g_1 = threadContextElements(this.f1g_1);
        var tmp = this;
        tmp.h1g_1 = UndispatchedContextCollector$emitRef$slambda_0(downstream);
      }
      *h1d(value, $completion) {
        return yield* /*#__NOINLINE__*/withContextUndispatched(this.f1g_1, value, this.g1g_1, this.h1g_1, $completion);
      }
    }
    initMetadataForClass($, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector()], [1]);
    UndispatchedContextCollectorClass = $;
  }
  return UndispatchedContextCollectorClass;
}
var StackFrameContinuationClass;
function StackFrameContinuation() {
  if (StackFrameContinuationClass === VOID) {
    class $ {
      constructor(uCont, context) {
        this.i1g_1 = uCont;
        this.j1g_1 = context;
      }
      mc() {
        return this.j1g_1;
      }
      oc(result) {
        this.i1g_1.oc(result);
      }
    }
    initMetadataForClass($, 'StackFrameContinuation', VOID, VOID, [Continuation()]);
    StackFrameContinuationClass = $;
  }
  return StackFrameContinuationClass;
}
//region block: exports
export {
  fuse$default as fuse$default20ez9dp5pjoz7,
  ChannelFlowOperatorImpl as ChannelFlowOperatorImpl3gjkp847e0ebc,
  ChannelFlow as ChannelFlowvdfy82kdxy2m,
  FusibleFlow as FusibleFlow2tgh9s2p1kryd,
};
//endregion

//# sourceMappingURL=ChannelFlow.mjs.map
